import { Component, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {GlobalMessageService, Product, ProductSearchPage, SearchConfig} from '@spartacus/core';
import { PageLayoutService, ProductListComponent, ProductListComponentService, ViewConfig } from '@spartacus/storefront';
import { filter, tap } from 'rxjs/operators';
import { UigExportProductsComponent } from 'src/app/components/uig-export-products/uig-export-products.component';
import { UigExportProductsService } from 'src/app/components/uig-export-products/uig-export-products.service';
import { UigExportProductSearchService } from './uig-export-product-search.service';



@Component({
    selector: 'app-uig-product-list',
    templateUrl: './uig-product-list.component.html',
    styleUrls: ['./uig-product-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigProductListComponent extends ProductListComponent {

  query: string;

  constructor(
    private modalService: NgbModal,
    pageLayoutService: PageLayoutService,
    productListComponentService: ProductListComponentService,
    scrollConfig: ViewConfig,
    globalMessageService: GlobalMessageService,
    private exportProductsService: UigExportProductsService) {

    super(pageLayoutService, productListComponentService, globalMessageService, scrollConfig);
  }


  onExport() {

    this.model$
      .pipe(
        filter((model) => model != null),
        tap((model) => {
          this.query = model.currentQuery.query.value;
        })
      )
      .subscribe();

    this.modalService.open(UigExportProductsComponent, { centered: true }).result.then(
      (result) => {
        if (result === 'print') {
          window.print();
        } else {
          this.exportProductsService.exportProductListWithSelectedExportColumns(result, this.query);
        }
      },
      (reason) => { }
    );

  }

}
